import { CompanyTemplatePropertiesService } from '@beeboard/common';
import { defineStore } from 'pinia';
import type {
  CompanyTemplateProperty,
  CreateCompanyTemplateProperty,
  UpdateCompanyTemplateProperty,
} from '@beeboard/common';

export type TemplateCustomPropertiesStoreState = {
  companyTemplateProperties: CompanyTemplateProperty[];
};

export const useTemplateCustomPropertiesStore = defineStore(
  'templateCustomPropertiesStore',
  {
    state: (): TemplateCustomPropertiesStoreState => ({
      companyTemplateProperties: [] as CompanyTemplateProperty[],
    }),

    getters: {
      hasTemplateCustomProperties(state): boolean {
        return state.companyTemplateProperties.length > 0;
      },
    },

    actions: {
      write(property: CompanyTemplateProperty) {
        const properties = this.$state.companyTemplateProperties;
        const oldProperty = properties.find((p) => p.id === property.id);
        if (oldProperty) {
          Object.assign(oldProperty, property);
        } else {
          properties.push(property);
        }
      },

      async loadCompanyTemplateProperties() {
        const response =
          await CompanyTemplatePropertiesService.getCompanyTemplateProperties();
        this.$patch({ companyTemplateProperties: response.items });
      },

      async create(payload: CreateCompanyTemplateProperty) {
        const property =
          await CompanyTemplatePropertiesService.createCompanyTemplateProperty(
            payload,
          );
        this.write(property);
      },

      async update(propertyId: string, payload: UpdateCompanyTemplateProperty) {
        const property =
          await CompanyTemplatePropertiesService.updateCompanyTemplateProperty(
            propertyId,
            payload,
          );
        this.write(property);
      },

      async delete(propertyId: string, force = false) {
        await CompanyTemplatePropertiesService.deleteCompanyTemplateProperty(
          propertyId,
          force,
        );
        const properties = this.$state.companyTemplateProperties;
        const propertyIndex = properties.findIndex((p) => p.id === propertyId);
        if (propertyIndex > -1) {
          properties.splice(propertyIndex, 1);
        }
      },
    },
  },
);
